module.exports = __webpack_public_path__ + "static/media/cian-profile-body.e7ec329d.jpg";